export const PrivateMobileSecond = () => {
    return <div>
        <div className="mt-[45px] flex justify-center px-[45px]"><div className="text-[18px] font-bold text-[rgba(51,51,51,1)]">我们可以解决哪些问题？</div></div>
        <div className="flex flex-col justify-between mt-[40px] gap-[25px] w-full h-[auto] px-[25px]">
            <Item
                title="内网访问管控难"
                content="由于访问请求和业务流量需要经由公共互联网链路，内网应用暴露在公网上存在安全风险，如何管控访问请求和流量成为难题"
            />
            <Item
                title="跨国业务访问体验差"
                content="传统互联网组网方案无法接入国际专线;在关键业务应用的访问体验上表现差劲;我们组网方案均采购来自于三大运营商的合规稳定国际专线"
                direction="right"
            />
            <Item
                title="业务多云接入困难"
                content="业务上云、大量采购第三方业务应用成为业务架构新形态，企业不再是单一数据中心，而是逐渐采用分布式业务系统、私有云公有云混合部署接入困难"
            />
            <Item
                title="自建成本高难维护"
                content="采用传统组网方案自行搭建，对技术研发能力要求高，价格贵、后期维护难、不够灵活等问题:我们根据1V1资讯整理最优方案，选择高性价比的资源快速部署并提供专业售后维护"
                direction="right"
            />
        </div>

        <div className="flex mt-[30px] px-[25px] justify-center items-center">
            <img
                className="w-[63px] h-[63px] min-w-[63px] min-h-[63px]"
                src="/imgs/private/2.png"
            />
            <div className="bg-gradient-to-r from-[#FFFFFF] via-[#1FB4EE] via-[#0076FD] to-[#FFFFFF] h-[2px] w-full "></div>
            <img
                className="w-[58px] h-[58px] min-w-[58px] min-h-[58px]"
                src="/imgs/private/3.png"
            />
        </div>
    </div>
}


export const Item = (props: { title: string; content: string; direction?: "left" | "right" }) => {
    const { direction = "left" } = props;
    return (
        <div className="relative w-full h-[116px]">
            <div className={`w-full h-[116px] bg-gradient-to-br from-[#00B9E7] to-[#0071FE] rounded-[11px] absolute top-[-10px] z-1 ${direction === "left" ? "left-[-10px]" : "right-[-10px]"}`}></div>
            <div className="w-full h-[116px] bg-gradient-to-br from-[#FFFFFF] to-[#D7E3FF] shadow-[0px_4px_10px_0px_rgba(0,0,0,0.08)] rounded-[11px] absolute top-0 left-0 z-2 p-[20px]">
                <div className="font-normal text-[12px] text-left bg-gradient-to-t from-[#02ABEB] to-[#0074FD] bg-clip-text text-transparent">
                    {props.title}
                </div>
                <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[12px] text-[#003366] mt-[10px]">
                    {props.content}
                </div>
            </div>
        </div>
    );
};
